import { trackClientEvent } from '../../../../trackClientEvent';
export var eventKey = 'logged_out_retailers-discover_page_all_filters_pill-click';
/**
 * This event tracks when users click on the &#39;All Filters&#39; pill on the discover page to show&#x2F;hide the filter sidebar.
 */ export function trackLoggedOutRetailersDiscoverPageAllFiltersPillClick(Action) {
    return trackClientEvent({
        eventKey: eventKey,
        realTimeTracking: false,
        parameters: {
            Action: Action
        }
    });
}
